module.exports = __webpack_public_path__ + "static/img/18.f695360.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/18.png
// module id = Xywf
// module chunks = 0